import React from "react";
import { MessageCircle } from "lucide-react";
import { RESTAURANT } from "../../lib/restaurantData";
import { useT } from "../../lib/i18n";

export const WhatsAppFab = () => {
  const { t } = useT();
  const url = `https://wa.me/${RESTAURANT.whatsapp}?text=${encodeURIComponent(t("whatsappMsg"))}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white grid place-items-center shadow-2xl hover:scale-110 hover:shadow-[0_20px_40px_rgba(37,211,102,0.4)] transition-transform"
    >
      <MessageCircle className="w-7 h-7 sm:w-8 sm:h-8" fill="white" />
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
    </a>
  );
};
